import { observer } from "mobx-react-lite"
import { DeviceType, usePreviewStore } from "../stores/Preview"
import { Computer, Smartphone, TabletMac } from "@material-ui/icons"
import { Button } from "@/components/Button/Button"
import { PageSelect } from "@/components/widgets/PageSelect"
import { HeaderContainer } from "@/components/widgets/HeaderContainer"
import { PublishButton } from "@/features/history/PublishButton"
import { SaveButton } from "@/features/history/SaveButton"
import { Switch } from "@/components/Switch/Switch"


export const Header = observer(() => {
    const preview = usePreviewStore()

    return (
        <HeaderContainer>
            <div></div>
            <div className="flex gap-2">
                <Button variant="icon" onPress={() => preview.setDevice(DeviceType.Mobile)}><Smartphone/></Button>
                <Button variant="icon" onPress={() => preview.setDevice(DeviceType.Tablet)}><TabletMac/></Button>
                <Button variant="icon" onPress={() => preview.setDevice(DeviceType.Computer)}><Computer/></Button>
            </div>
            <div>
                <Switch isSelected={preview.isPreviewing} onChange={(val) => preview.isPreviewing = val}>
                    Preview
                </Switch>
            </div>
        </HeaderContainer>
    )
})